import React, { Component } from 'react';
import _ from 'lodash';
import DisableNextModal from '../../../shared/Common/disableNextModal';
import ValidationTab from './ValidationTab/ValidationTab';
import CustomerGroupModal from './CustomerGroupModal/CustomerGroupModal';
import uuidv1 from 'uuid/v4';

class ValidationMatrix extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            stepSecondValidation: false,
            customerModal: false,
            tabs: [],
            delete: false
        };
    }
    componentDidMount() {
        let body = {
            projectId: this.props.projectId,
            type: "segmentation"
        }
        let data = {
            projectId: this.props.projectId,
            type: "benefitsLadder"
        }
        this.props.getSegmentation(body)
        this.props.getBenefitsLadder(data)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.segmentation.segmentationFetched && nextProps.benefits.benefitsLadderFetched && nextProps.segmentation.segmentationData.Items.length !== 0 && this.state.tabs.length === 0) {
            this.setState({
                segmentation: nextProps.segmentation.segmentationData.Items[0],
                benefits: nextProps.benefits.benefitsLadderData.Items[0].data
            })
        }
    }
    componentDidUpdate(prepProps) {
        if (this.props.segmentation.segmentationFetched && this.props.benefits.benefitsLadderFetched && this.props.segmentation.segmentationData.Items.length !== 0 && this.state.tabs.length === 0 && this.state.segmentation && !this.state.delete) {
            let tabs = [];
            let segments = _.cloneDeep(this.state.segmentation.segments)
            let segmentation = _.cloneDeep(this.state.segmentation.segmentation)
            let benefits = _.cloneDeep(this.state.benefits)
            let groups = _.uniqBy(this.state.segmentation.segments, "groupId");
            let seg = []
            segments.map(segment => {
                benefits.map(benefit => {
                    if (segment.groupId === benefit.groupId) {
                        benefit.benefits.map(ben => {
                            let gag = _.find(segmentation, function (o) { return o.benefitId === ben.id });
                            if (!gag && ben.important) {
                                seg.push({
                                    groupId: segment.groupId,
                                    benefitId: ben.id,
                                    segmentId: segment.segmentId,
                                    value: "1"
                                })
                            }
                        })
                    }
                })
            })
            segmentation = [...segmentation, ...seg]
            benefits.map(benefit => {
                groups.map(group => {
                    if (benefit.groupId === group.groupId) {
                        let importants = [];
                        benefit.benefits.map(benefits => {
                            if (benefits.important) {
                                importants.push(benefits)
                            }
                        })
                        tabs.push({
                            groupName: benefit.groupName,
                            groupId: group.groupId,
                            segments: _.filter(segments, (o) => { return o.groupId === group.groupId }),
                            segmentation: _.filter(segmentation, (o) => { return o.groupId === group.groupId }),
                            benefits: importants
                        })
                    }
                })

            })

            if (tabs.length > 0) {
                this.setState({ tabs })
            }
        }
    }
    onPlusBtn = () => {
        this.setState({
            customerModal: true
        })
        let body = {
            projectId: this.props.projectId,
            type: "benefitsLadder"
        }
        this.props.getBenefitsLadder(body)
    }
    onAddCustomerGroupClose = () => {
        this.setState({
            customerModal: false
        })
    }
    onAddCustomerGroup = (requestData, step) => {
        // if (step === "1") {
        let tabs = this.state.tabs
        let segments = [];
        let segmentation = [];
        for (let i = 0; i < 6; i++) {
            let id = uuidv1();
            segments.push({
                groupId: requestData.groupId,
                segmentId: id,
                name: '',
                percent: 0,
                orederId: +segments.length + 1
            })
            // debugger
        }
        requestData['segments'] = segments;
        segments.map((segment, index) => {
            requestData.benefits.map(benefit => {
                segmentation.push({
                    groupId: requestData.groupId,
                    benefitId: benefit.id,
                    segmentId: segment.segmentId,
                    value: "1"
                })
            })
        })
        requestData['segmentation'] = segmentation
        tabs.push(requestData)
        this.setState(tabs)
        // }
        this.setState({
            customerModal: false
        })
    }
    onDeletTab = (groupName) => {
        let tabs = this.state.tabs
        tabs = _.filter(tabs, (o) => { return o.groupName !== groupName })
        this.setState({ tabs: tabs, delete: true })
    }
    onChangeSegmentName = (e, groupId) => {
        let tabs = [...this.state.tabs];
        tabs.map(tab => {
            if (tab.groupId === groupId) {
                tab.segments.map(segment => {
                    if (segment.id === e.target.id || segment.segmentId === e.target.id) {
                        segment.name = e.target.value
                    }
                })
            }
        })
        this.setState({ tabs })
    }
    onChangeSegmentationValue = (e, benefitid, groupId) => {
        let tabs = this.state.tabs;
        tabs.map(tab => {
            if (tab.groupId === groupId) {
                tab.segmentation.map((segmentation => {
                    if (segmentation.benefitId === benefitid && segmentation.segmentId === e.target.id) {
                        segmentation.value = e.target.value
                    }
                }))
                this.checkValues(tab.segments, tab.segmentation)
            }
        })
        this.setState({ tabs })
    }
    onSegmentAdd = (groupId) => {
        let tabs = this.state.tabs
        tabs.map(tab => {
            if (tab.groupId === groupId) {
                let id = uuidv1();
                tab.segments.push({
                    groupId: groupId,
                    segmentId: id,
                    name: '',
                    percent: 0,
                    orederId: +tab.segments.length + 1
                })
                tab.benefits.map((benefit) => {
                    tab.segmentation.push({
                        groupId: groupId,
                        benefitId: benefit.id,
                        segmentId: tab.segments[tab.segments.length - 1].segmentId,
                        value: "1"
                    })
                })
            }
        })
        this.setState({ tabs })
    }
    onSegmentDelete = (groupId, segmentId) => {
        let tabs = this.state.tabs;
        tabs.map(tab => {
            if (tab.groupId === groupId) {
                tab.segments = _.filter(tab.segments, (o) => { return o.segmentId !== segmentId })
                tab.segmentation = _.filter(tab.segmentation, (o) => { return o.segmentId !== segmentId })
            }
        })
        this.setState({
            tabs
        })
    }
    checkValues = (segments, segmentation) => {
        let returnVal = false;
        for (let i in segments) {
            if (segments[i].name !== "") {
                let seg = document.getElementsByClassName(segments[i].segmentId)
                let values = []
                for (let j in seg) {
                    if (seg[j].value !== undefined) {
                        values.push(seg[j].value);
                        seg[j].style.border = '1px solid rgb(166, 166, 166)';
                    }
                }
                for (let n = 0; n < values.length; n++) {
                    for (let m = n + 1; m < values.length; m++) {
                        if (values[n] === values[m]) {
                            seg[n].style.border = '2px solid red';
                            seg[m].style.border = '2px solid red';
                            returnVal = true;
                        }
                    }
                }
            }
        }
        // for (let i in segments) {
        //     if (segments[i].name !== "") {
        //         let segmentsobjects = _.filter(segmentation, { "segmentId": segments[i].segmentId })
        //         let uniq = _.uniqBy(segmentsobjects, 'value');
        //         if (segmentsobjects.length !== uniq.length) {
        //             debugger
        //             return true
        //         }
        //     }
        // }
        return returnVal;
    }
    nextLevel = () => {
        let segmentation = [];
        let segments = [];
        if (this.state.tabs.length > 0) {
            this.state.tabs.map(item => {
                segmentation.push(...item.segmentation);
                segments.push(...item.segments);
            })
            let newSegmentation = []
            let newSegments = _.filter(segments, (o) => { return o.name !== "" })
            if (newSegments.length > 0) {
                newSegments.map(segment => {
                    segmentation.map(segm => {
                        if (segment.segmentId === segm.segmentId) {
                            newSegmentation.push(segm)
                        }
                    })
                })
            }
            let body = {
                type: "segmentation",
                projectId: this.props.projectId,
                segmentation: newSegmentation,
                segments: newSegments,
            }

            body['segmentation'] = newSegmentation;
            if (this.checkValues(segments, segmentation) || newSegments.length === 0) {
                this.props.disableNextModal();
            } else {
                if (this.props.segmentation.segmentationData.Items.length === 0) {
                    this.props.addSegmentation(body)
                }
                if (this.props.segmentation.segmentationData.Items.length > 0) {
                    body.projectId = this.props.segmentation.segmentationData.Items[0].projectId
                    body['id'] = this.props.segmentation.segmentationData.Items[0].id
                    this.props.editSegmentation(body)
                }
                this.props.groupStateNext()
            }
        } else {
            this.props.disableNextModal();
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                {!this.props.segmentation.segmentationFetching && <div className='container-fluid'>
                    <div className="row">
                        <div className="col-sm-12">
                            <h5>SEGMENTATION</h5>
                        </div>
                    </div>
                    <div className='row'>

                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Segment Profiling</h5>
                                    <span>Create up to six segments by rank-ordering the benefits differently for each; and then name the segment</span>
                                </div>
                                <div className='card-body'>
                                    <ValidationTab
                                        onPlusBtn={this.onPlusBtn}
                                        benefits={this.props.benefits}
                                        tabs={this.state.tabs}
                                        getImportantBenefits={this.props.getImportantBenefits}
                                        projectId={this.props.projectId}
                                        resetImportants={this.props.resetImportants}
                                        segmentation={this.props.segmentation}
                                        onDeletTab={this.onDeletTab}
                                        onChangeSegmentName={this.onChangeSegmentName}
                                        onChangeSegmentationValue={this.onChangeSegmentationValue}
                                        onSegmentAdd={this.onSegmentAdd}
                                        onSegmentDelete={this.onSegmentDelete}
                                        tabStep={this.props.tabStep}
                                        onTabChange={this.props.onTabChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div onClick={this.nextLevel} className='btn btn-success'> Next </div>
                                    <a href="/toolkit" className='btn empty-btn default'> Back </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>}
                {this.state.customerModal && <CustomerGroupModal
                    segmentation={this.props.segmentation}
                    benefits={this.props.benefits}
                    onAddCustomerGroup={this.onAddCustomerGroup}
                    onAddCustomerGroupClose={this.onAddCustomerGroupClose}
                    tabs={this.state.tabs}
                />
                }
                {this.props.segmentation.segmentationFetching &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
                {this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='Ranks for each benefit must be unique'
                        disableModalTitle='Notice'
                    />

                }
            </div>
        )
    }
}

export default (ValidationMatrix);



// WEBPACK FOOTER //
// ./src/components/Segmentation/ValidationMatrix/ValidationMatrix.jsx